import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { OverlayLayoutComponent } from "@m19-board/overlay/overlay-layout/overlay-layout.component";
import { OverlayRule } from "@m19-board/overlay/overlay-service/overlay-rules";

@Component({
  selector: "app-bidder-off-whitelabel-overlay",
  imports: [TranslocoDirective, OverlayLayoutComponent],
  template: `
    <app-overlay-layout *transloco="let t" variant="info" icon="pauseCircle" [title]="t('overlays.bidder_off_title')">
      <p overlayBody>{{ t("overlays.bidder_off_whitelabel_reason") }}</p>
      <p overlayBody>{{ t("overlays.bidder_off_whitelabel_action") }}</p>
    </app-overlay-layout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BidderOffWhitelabelOverlayComponent {
  static readonly rule = OverlayRule.BIDDER_OFF_WHITELABEL;
}
